import React from 'react';

import { Trans } from '@lingui/macro';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Icon from '@mui/icons-material/Videocam';

import NDISelector from '../../../misc/NDISelector';
import FormInlineButton from '../../../misc/FormInlineButton';

const useStyles = makeStyles(() => ({
    gridContainer: {
        marginTop: '0.5em',
    },
}));

const initSettings = (initialSettings) => {
    if (!initialSettings) {
        initialSettings = {};
    }

    const settings = {
        name: '',
        ...initialSettings,
    };

    return settings;
};

const createInputs = (settings) => {
    const address = '{ndi,name=' + settings.name + '}';
    const input = {
        address: address,
        // NDI is already a live real-time source; -re is not needed and
        // causes stale-timeout loops when the NDI sender has any micro-pause.
        options: ['-f', 'libndi_newtek'],
    };

    return [input];
};

function Source(props) {
    const classes = useStyles();
    const settings = initSettings(props.settings);

    const [ndiOpen, setNdiOpen] = React.useState(false);

    const handleChange = (ev) => {
        const newSettings = { ...settings, name: ev.target.value };
        props.onChange(id, newSettings, createInputs(newSettings), newSettings.name.trim().length > 0);
    };

    const handleProbe = () => {
        props.onProbe(settings, createInputs(settings));
    };

    const handleNdiProceed = (name) => {
        const newSettings = { ...settings, name };
        props.onChange(id, newSettings, createInputs(newSettings), true);
        setNdiOpen(false);
        // Immediately trigger probe so the wizard moves to the probe step automatically
        props.onProbe(newSettings, createInputs(newSettings));
    };

    return (
        <React.Fragment>
            <Grid container alignItems="flex-start" spacing={2} className={classes.gridContainer}>
                <Grid item xs={12}>
                    <Typography>
                        <Trans>Select an NDI source to use as video input.</Trans>
                    </Typography>
                </Grid>
                <Grid item xs={12} md={9}>
                    <TextField
                        variant="outlined"
                        fullWidth
                        label={<Trans>NDI source</Trans>}
                        value={settings.name}
                        onChange={handleChange}
                        placeholder={"e.g. MyNDISource"}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                const name = (settings.name || '').trim();
                                if (name.length > 0) {
                                    handleProbe();
                                }
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <Button variant="outlined" onClick={() => setNdiOpen(true)}>
                        <Trans>Buscar dispositivos NDI</Trans>
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <FormInlineButton onClick={handleProbe} disabled={!settings.name || settings.name.trim().length === 0}>
                        <Trans>Probe</Trans>
                    </FormInlineButton>
                </Grid>

                {props.restreamer && (
                    <NDISelector open={ndiOpen} onClose={() => setNdiOpen(false)} onProceed={handleNdiProceed} restreamer={props.restreamer} i18n={props.i18n} notify={props.notify} />
                )}
            </Grid>
        </React.Fragment>
    );
}

Source.defaultProps = {
    knownDevices: [],
    settings: {},
    onChange: function (type, settings, inputs, ready) {},
    onProbe: function (settings, inputs) {},
    onRefresh: function () {},
    onStore: function (name, data) {
        return '';
    },
};

function SourceIcon(props) {
    return <Icon style={{ color: '#FFF' }} {...props} />;
}

const id = 'ndi';
const name = <Trans>NDI</Trans>;
const capabilities = ['video', 'audio'];
const ffversion = '^5.0.0 || ^6.0.0';

const func = {
    initSettings,
    createInputs,
};

export { id, name, capabilities, ffversion, SourceIcon as icon, Source as component, func };
